export type Level = (typeof LEVELS)[number]

/** Ordered from least to most severe. The index is the rank the minimum-level gate compares. */
export const LEVELS = ['debug', 'info', 'warn', 'error'] as const

export function isLevel(value: unknown): value is Level {
  return LEVELS.some((level) => level === value)
}

/** `true` when a call at `level` passes a gate set to `minimum`. */
export function passesLevel(level: Level, minimum: Level): boolean {
  return LEVELS.indexOf(level) >= LEVELS.indexOf(minimum)
}
